import React from "react";
import { Box, Typography, IconButton, TruncateTooltip } from "@tiny/components";
import Download from "@tiny/icons/generated/Download";
import { useCleanedListHistoryRow } from "./CleanedListHistoryRow.hooks";
import { format } from "date-fns";

export interface CleanedListHistoryRowProps {
  item: {
    id: string;
    fileName: string;
    cleanupAt: string;
  };
  onDownloadComplete?: () => void;
}

function CleanedListHistoryRow(props: CleanedListHistoryRowProps) {
  const { item } = props;
  const { downloadCleanedFile } = useCleanedListHistoryRow(props);

  const formattedDate = React.useMemo(() => {
    try {
      return format(new Date(item.cleanupAt), "MMM dd, yyyy HH:mm");
    } catch {
      return item.cleanupAt;
    }
  }, [item.cleanupAt]);

  return (
    <Box
      display="flex"
      alignItems="center"
      justifyContent="space-between"
      py={2}
      px={1}
      borderBottom="1px solid #e0e0e0"
    >
      <Box flex={1} minWidth={0} flexDirection="column">
        <TruncateTooltip arrow>
          <Typography
            variant="body2"
            color="grey"
            tone={900}
            noWrap
            fontWeight="semiBold"
            component={"div"}
          >
            {item.fileName}
          </Typography>
        </TruncateTooltip>
        <Typography
          variant="label3"
          color="grey"
          tone={600}
          component={"div"}
          mt={1}
        >
          Cleaned on {formattedDate}
        </Typography>
      </Box>
      <Box>
        <TruncateTooltip arrow title="Download">
          <IconButton
            onClick={() => downloadCleanedFile(item.id)}
            color="primary"
            size="large"
          >
            <Download />
          </IconButton>
        </TruncateTooltip>
      </Box>
    </Box>
  );
}

export default CleanedListHistoryRow;
